import {
  useOperatorTimelineSegments,
  useIsTimelineExpanded,
} from "components/Dashboard/HubletView/SingleTimeline/singleTimelineStore";
import { TAGHIGHLIGHT_BACKDROP_HEIGHT } from "components/Dashboard/HubletView/SingleTimeline/TagHighlightTimelineBackdrop";
import { SERVER_NAMES } from "components/Nav/Drawers/RightDrawer/FlightDebugger/SERVER_NAMES";
import { useSelector } from "store/useSelector";
import { useTimeAxisContext } from "utils/customHooks/genericHooks";
import { OperatorCanvas, OperatorTooltip } from "./OperatorCanvas";
import { getTimelineOffsetY, SEGMENT_MARGIN } from "./skuOperatorTimelineUtils";
import { safariOffset } from "./safariOffset";

export function OperatorSegments({
  processId,
  order,
  width,
}: {
  processId: string;
  order: number;
  width: number;
}) {
  const operatorTimelineSegments = useOperatorTimelineSegments();
  const [isTimelineExpanded] = useIsTimelineExpanded();
  const timelineOffsetY = getTimelineOffsetY(order);
  const { xLeft, xRight, scaleTime } = useTimeAxisContext();
  const visibleRange = useSelector(s => s.legacy.visibleRange);
  const x0 = visibleRange?.ge ? scaleTime(visibleRange.ge) || 0 : xLeft;
  const x1 = visibleRange?.lt
    ? scaleTime(visibleRange.lt) || 0
    : Math.min(scaleTime(Date.now()), xRight);
  const rectLeft = Math.max(x0, xLeft);
  const rectRight = Math.min(x1, xRight);
  const rectWidth = rectRight - rectLeft;

  return (
    <>
      <foreignObject
        x={rectLeft}
        y={timelineOffsetY + safariOffset}
        height={TAGHIGHLIGHT_BACKDROP_HEIGHT}
        width={Math.max(0, rectWidth - SEGMENT_MARGIN / 2)}
        data-server-names={[SERVER_NAMES.midgardDataDumpRows]}
        className={`operator-segments`}
      >
        <OperatorCanvas
          width={width}
          isTimelineExpanded={isTimelineExpanded}
          operatorSegments={operatorTimelineSegments[processId] || []}
          processId={processId}
        />
      </foreignObject>
      <OperatorTooltip order={order} />
    </>
  );
}
